import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const ridesOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.RIDES,
    steps: [
        {
            id: "ride-welcome",
            title: "Gestão de Corridas",
            description:
                "Aqui você monitora todas as corridas realizadas na plataforma, incluindo status, valores e detalhes.",
            position: "center",
        },
        {
            id: "ride-table",
            title: "Tabela de Corridas",
            description:
                "Visualize origem, destino, valor, status e data de cada corrida. Clique para ver os detalhes completos.",
            targetId: "rides-table",
            position: "bottom",
        },
        {
            id: "ride-filters",
            title: "Filtros Avançados",
            description:
                "Filtre corridas por período, status (completas, canceladas, em andamento) e tipo de pagamento.",
            targetId: "rides-filters",
            position: "bottom",
        },
        {
            id: "ride-details",
            title: "Detalhes da Corrida",
            description:
                "Ao clicar em uma corrida, veja o trajeto no mapa, dados do motorista/passageiro e informações de pagamento.",
            targetId: "rides-actions",
            position: "left",
        },
    ],
};
